import { Component, Input, OnInit } from '@angular/core';
import { NoiseAbatement } from '../models/noise-abatement.model';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { Airport } from '../models/airport.model';
import { MatDialog, MatDialogConfig, MatSnackBar } from '@angular/material';
import { EditNoiseAbatementComponent } from '../edit-noise-abatement/edit-noise-abatement.component';
import { DeleteNoiseAbatementComponent } from '../delete-noise-abatement/delete-noise-abatement.component';


@Component({
  selector: 'app-noise-abatement',
  templateUrl: './noise-abatement.component.html',
  styleUrls: ['./noise-abatement.component.scss']
})
export class NoiseAbatementComponent implements OnInit {
  @Input() airport: Airport;
  editModeSet: boolean;

  constructor( private _toggleService: EditToggleService,
               public _snackBar: MatSnackBar,
               private _editNoiseAbatementDialog: MatDialog,
               private _deleteNoiseAbatementDialog: MatDialog
  ) {}

  ngOnInit() {
    this._toggleService.toggleEmitter.subscribe(isOn => {
      this.editModeSet = isOn;
    });
  }

  public formatAppliesTo(appliesTo: any): string {
    return NoiseAbatement.formatAppliesTo(appliesTo);
  }

  public formatAppDep(appDep: any): string {
    return NoiseAbatement.formatAppDep(appDep);
  }

  openEditNoiseDialog(index: number) {
    const dialogConfig = new MatDialogConfig();
    const ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '60%';
    dialogConfig.data = {
      airID: this.airport.airportId,
      id: null,
      isNew: false,
      landingSurfaces: this.airport.landingSurfaces
    };
    index == null ? dialogConfig.data.isNew = true : dialogConfig.data.noise = this.airport.noiseAbatement[index];
    dialogConfig.data['airID'] = this.airport.airportId;
    dialogConfig.width = '60%';
    const dialogRef = this._editNoiseAbatementDialog.open(EditNoiseAbatementComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((isUpdated) => {
      if (!isUpdated) { return; } // required to handle backdrop click.
      if (isUpdated.cancelBtnClicked) { return; }
      // isUpdated.success will be false if there is an error during any of the api calls.
      if (isUpdated.success) {
        if (isUpdated.isNew) {
          this.airport.noiseAbatement.push(isUpdated.noise);
          this._snackBar.open('Noise Abatement', 'Added', {
            duration: 2000
          });
        } else {
          this._snackBar.open('Noise Abatement', 'Updated', {
            duration: 2000
          });
        }
      } else {
        this._snackBar.open(ERROR_MSG, 'Error', {
          duration: 6000
        });
      }
    });
  }

  deleteNoise(index: number) {
    const dialogConfig = new MatDialogConfig();
    const ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      airportId: this.airport.airportId,
      noiseId: this.airport.noiseAbatement[index].id
    };
    const dialogRef = this._deleteNoiseAbatementDialog.open(DeleteNoiseAbatementComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((isUpdated) => {
      if (!isUpdated) { return; } // required to handle backdrop click.
      if (isUpdated.cancelBtnClicked) { return; }
      // isUpdated.success will be false if there is an error during any of the api calls.
      if (isUpdated.success) {
        this._snackBar.open('Noise Abatement', 'Deleted', {
          duration: 2000
        });
        this.airport.noiseAbatement.splice(index, 1);
      } else {
        this._snackBar.open(ERROR_MSG, 'Error', {
          duration: 6000
        });
      }
    });
  }
}
